import type { SchoolPlan } from "@/types";

/**
 * Forfaits d'abonnement : même règles que le serveur (Backend/src/modules/school/plans.ts), qui seul les
 * applique. Ici, uniquement pour l'affichage et les contrôles avant envoi.
 */
export const PLAN_ORDER: SchoolPlan[] = [
  "ESSENTIEL",
  "ETABLISSEMENT",
  "RESEAU",
];

export const PLAN_LABEL: Record<SchoolPlan, string> = {
  ESSENTIEL: "Essentiel",
  ETABLISSEMENT: "Établissement",
  RESEAU: "Réseau",
};

export const PLAN_SUMMARY: Record<SchoolPlan, string> = {
  ESSENTIEL:
    "1 cycle, 400 élèves, 2 comptes ; sans dépenses, budget, personnel ni paie",
  ETABLISSEMENT: "Deux cycles, élèves et comptes illimités, tous les modules",
  RESEAU: "Plusieurs écoles, chacune avec tous les modules (sur devis)",
};

/** Nombre de cycles au plus (null : sans limite). */
export const PLAN_MAX_CYCLES: Record<SchoolPlan, number | null> = {
  ESSENTIEL: 1,
  ETABLISSEMENT: null,
  RESEAU: null,
};

/** L'école est prévenue 30 jours avant la fin de son abonnement. */
export const SUBSCRIPTION_WARNING_DAYS = 30;

function todayIso(): string {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** État de l'abonnement : échu le lendemain de sa date de fin. */
export function subscriptionState(endsAt: string | null | undefined): {
  expired: boolean;
  /** Jours restants (0 : dernier jour), null sans échéance. */
  daysLeft: number | null;
} {
  if (!endsAt) return { expired: false, daysLeft: null };
  const today = todayIso();
  const days = Math.round(
    (Date.parse(`${endsAt}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) /
      86_400_000,
  );
  return { expired: endsAt < today, daysLeft: days };
}
